export default __webpack_public_path__ + "static/media/StainlessSteelsImg.fbbde34d.jpg";